/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Restore_Success_TitleInputs */

const en_dialog_restore_success_title = /** @type {(inputs: Dialog_Restore_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restore Successful`)
};

const ar_dialog_restore_success_title = /** @type {(inputs: Dialog_Restore_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استعادة ناجحة`)
};

const de_dialog_restore_success_title = /** @type {(inputs: Dialog_Restore_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erfolgreich wiederherstellen`)
};

const es_dialog_restore_success_title = /** @type {(inputs: Dialog_Restore_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restauración exitosa`)
};

const fr_dialog_restore_success_title = /** @type {(inputs: Dialog_Restore_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Récupération réussie`)
};

const it_dialog_restore_success_title = /** @type {(inputs: Dialog_Restore_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ripristino riuscito`)
};

const ja_dialog_restore_success_title = /** @type {(inputs: Dialog_Restore_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`復元に成功しました`)
};

const ko_dialog_restore_success_title = /** @type {(inputs: Dialog_Restore_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`복원 성공`)
};

const pt_br_dialog_restore_success_title = /** @type {(inputs: Dialog_Restore_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restauração realizada com sucesso`)
};

const ru_dialog_restore_success_title = /** @type {(inputs: Dialog_Restore_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Восстановление успешно`)
};

const th_dialog_restore_success_title = /** @type {(inputs: Dialog_Restore_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การกู้คืนสำเร็จ`)
};

const tr_dialog_restore_success_title = /** @type {(inputs: Dialog_Restore_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geri Yükleme Başarılı`)
};

const zh_cn_dialog_restore_success_title = /** @type {(inputs: Dialog_Restore_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`恢复成功`)
};

const zh_tw_dialog_restore_success_title = /** @type {(inputs: Dialog_Restore_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`還原成功`)
};

/**
* | output |
* | --- |
* | "Restore Successful" |
*
* @param {Dialog_Restore_Success_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_restore_success_title = /** @type {((inputs?: Dialog_Restore_Success_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Restore_Success_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_restore_success_title(inputs)
	if (locale === "ar") return ar_dialog_restore_success_title(inputs)
	if (locale === "de") return de_dialog_restore_success_title(inputs)
	if (locale === "es") return es_dialog_restore_success_title(inputs)
	if (locale === "fr") return fr_dialog_restore_success_title(inputs)
	if (locale === "it") return it_dialog_restore_success_title(inputs)
	if (locale === "ja") return ja_dialog_restore_success_title(inputs)
	if (locale === "ko") return ko_dialog_restore_success_title(inputs)
	if (locale === "pt_br") return pt_br_dialog_restore_success_title(inputs)
	if (locale === "ru") return ru_dialog_restore_success_title(inputs)
	if (locale === "th") return th_dialog_restore_success_title(inputs)
	if (locale === "tr") return tr_dialog_restore_success_title(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_restore_success_title(inputs)
	return zh_tw_dialog_restore_success_title(inputs)
});